import './App.css';
import PageRouting from './PageRouting/PageRouting';

function App() {
  return (
    <div className='grid-container' id='app'>
      <PageRouting />
    </div>
  );
}

export default App;
